import styled from '@emotion/styled';

export const ProductOption = styled.div`
  display: grid;
  grid-template-columns: 80px auto 80px;
`

export const ProductCode = styled.span`
  font-size: 11px;
  color: rgb(180, 180, 180);
  padding-right: 10px;
`

export const ProductQuantity = styled.span`
  font-size: 12px;
  color: rgb(180, 180, 180);
  padding-left: 10px;
`
